<template>
	<page-container :page="page">
		<main-content
			:title="page.title || page.header"
			:content="page.content"
			:roomtypeid="page.bookingID"
			:color="page.color"
			:heading-image="page.headingImages && page.headingImages[0]"
		/>

		<highlights-map :items="activeHighlights" />

		<section class="page-faq align-center">
			<frequently-asked-questions
				v-if="page && page.frequentlyAskedQuestion"
				:header="page.frequentlyAskedQuestion.header"
				:items="page.frequentlyAskedQuestion.faqitems"
			/>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: highlights } = await useWebsiteFetch('highlights', {
	query: { language: locale.value },
	key: `${locale.value}/highlights`,
});

const activeHighlights = highlights.value
	.filter((category) => category.items.length)
	.filter((category) => category.active);
</script>
